import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { IndexComponent } from './index/index.component';
import { AuthComponent } from './auth.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { RegisterComponent } from './register/register.component';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { LoginComponent } from './login/login.component';
import { ReferralComponent } from './referral/referral.component';
import { ArticleComponent } from './index/article/article.component';
import { DeleteUserComponent } from './delete-user/delete-user.component';
import { SubscriptionPricesLoginComponent } from './subscription-prices-login/subscription-prices-login.component';

const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      { path: '', component: IndexComponent },
      { path: 'forget', component: ForgetPasswordComponent },
      { path: 'email-verification', component: EmailVerificationComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'login', component: LoginComponent },
      { path: 'delete-user', component: DeleteUserComponent },
      { path: 'article/:id', component: ArticleComponent },
      { path: 'referral', component: ReferralComponent },
      { path: 'subscription-prices', component: SubscriptionPricesLoginComponent },
      { path: 'terms-conditions/:lang', component: TermsConditionsComponent },
      { path: 'privacy-policy/:lang', component: PrivacyPolicyComponent },
      { path: 'contact-us/:lang', component: ContactUsComponent },
      { path: 'videos', loadChildren: () => import('./index/video/video.module').then(m => m.VideoModule) },
    ],
  },


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule { }
